import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs/BehaviorSubject";

@Injectable()
export class FeatureFlagService {
  hide_extra_reports = new BehaviorSubject<boolean>(true);
}



// WEBPACK FOOTER //
// ./src/app/shared/services/feature-flag/feature-flag.service.ts